import axios, { type AxiosInstance } from "axios";

// Use a fully-qualified base URL only when explicitly set (e.g. in production
// against a hosted API). In dev, leave unset so requests use a relative path
// and Vite's `/api` proxy (vite.config.ts) forwards them to ezx-server —
// keeping the request same-origin to avoid CORS.
const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

/**
 * Axios instance pointed at `/api/v2/carrier/*` on ezx-server. Bearer token
 * is injected per-request by the React Query hooks via `getAuthHeaders`.
 */
export const api: AxiosInstance = axios.create({
  baseURL: `${BASE_URL}/api/v2/carrier`,
});

export function getAuthHeaders(token: string | null): Record<string, string> {
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}
